export class CeremonyUI {
  readonly videoEl: HTMLVideoElement;
  private layer: HTMLDivElement;
  private textEl: HTMLDivElement;
  private fadeEl: HTMLDivElement;

  constructor(container: HTMLElement) {
    this.layer = document.createElement("div");
    this.layer.id = "ceremony-layer";
    this.layer.classList.add("hidden");

    this.textEl = document.createElement("div");
    this.textEl.className = "ceremony-text";
    this.layer.appendChild(this.textEl);

    this.videoEl = document.createElement("video");
    this.videoEl.id = "ceremony-video";
    this.videoEl.classList.add("hidden");

    this.fadeEl = document.createElement("div");
    this.fadeEl.className = "fade-black";

    container.append(this.layer, this.videoEl, this.fadeEl);
  }

  showLayer(): void {
    this.layer.classList.remove("hidden");
  }

  hideLayer(): void {
    this.layer.classList.add("hidden");
  }

  setText(text: string, big = false): void {
    this.textEl.classList.remove("hidden");
    this.textEl.textContent = text;
    this.textEl.classList.toggle("countdown-number", big);
    this.textEl.classList.toggle("ceremony-text", !big);
    // Force reflow so the pop animation restarts on repeated numbers.
    void this.textEl.offsetWidth;
    this.textEl.style.animation = "none";
    void this.textEl.offsetWidth;
    this.textEl.style.animation = "";
  }

  hideText(): void {
    this.textEl.classList.add("hidden");
  }

  fadeToBlack(on: boolean): void {
    this.fadeEl.classList.toggle("on", on);
  }

  showVideo(): void {
    this.hideText();
    this.videoEl.classList.remove("hidden");
  }

  hideVideo(): void {
    this.videoEl.classList.add("hidden");
  }

  dispose(): void {
    this.layer.remove();
    this.videoEl.remove();
    this.fadeEl.remove();
  }
}
